import Invoice from "./Invoice.js";
import Model from "../../Model.js";

/**
 * `invoiceGroup` represents a collection of invoices and stores
 * the total amount (value of the invoices) and balance amount
 * (what has already been paid). Please note this total and
 * balance are computed after conversion of invoice amounts to a
 * base currency.
 *
 * @param {invoice[]} [spec.invoices=[]] - Array of accountReceivable or accountPayables
 * @param {number} [spec.total=0] - Total value of the invoices after conversion to base currency
 * @param {number} [spec.balance=0] - Total value of what has already been paid after conversion to base currency
 */
export default class InvoiceGroup extends Model {
	constructor({ invoices = [], total = 0, balance = 0 }) {
		super(...arguments);
		this._invoices = invoices;
		this._total = total;
		this._balance = balance;
	}

	getInvoices() {
		return this._invoices;
	}

	getTotal() {
		return this._total;
	}

	getBalance() {
		return this._balance;
	}

	isSorted() {
		return false;
	}

	static transformMaterializationData(data, context) {
		super.transformMaterializationData(...arguments);

		data.invoices = Invoice.materializeAll(data.invoices, context);
	}
}
